import { jsxs as h, Fragment as y, jsx as s } from "react/jsx-runtime";
import { useTitle as Q } from "../../context/metadata/title.js";
import { useApp as H, useAppState as N } from "../../context/app/index.js";
import { useAuth as S } from "../../context/auth/index.js";
import { message as C } from "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { K as U } from "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { PullActionHandler as V } from "../pullactionhandler/index.js";
import { LoadingOverlay as q } from "../loadingoverlay/index.js";
import { Box as z, Alert as G, Button as b } from "@mui/material";
import f from "@mui/icons-material/Archive";
import J from "@mui/icons-material/MarkChatRead";
import { ArchiveFromDatePicker as W } from "./components/ArchiveFromDatePicker.js";
import { MessagingForm as X } from "./components/MessagingForm.js";
import { NewMessageButton as Y } from "./components/NewMessageButton.js";
import { useEffect as w } from "react";
import "../../types/interviews/index.js";
import { contacts as Z } from "../../types/contacts/index.js";
import "../../types/points/index.js";
import "../../types/projects/index.js";
import "../../types/groups/index.js";
var _ = /* @__PURE__ */ ((e) => (e[e.Reading = 1] = "Reading", e[e.Archiving = 2] = "Archiving", e[e.ArchivingRead = 3] = "ArchivingRead", e[e.ArchivingAll = 4] = "ArchivingAll", e))(_ || {});
const x = (e, c) => {
  switch (e) {
    case "1":
      return c !== 2 ? [
        { key: 1, label: "Mark all messages as read", icon: /* @__PURE__ */ s(J, {}) },
        { key: 2, label: "Archive read messages", icon: /* @__PURE__ */ s(f, {}) },
        { key: 3, label: "Archive all messages", icon: /* @__PURE__ */ s(f, {}) },
        { key: 4, label: "Archive selected messages", icon: /* @__PURE__ */ s(f, {}) }
      ] : void 0;
    case "3":
      return [
        { key: 5, label: "Restore selected messages", icon: /* @__PURE__ */ s(f, {}) }
      ];
    default:
      return;
  }
}, Ue = ({
  onMessageClick: e,
  onNewMessage: c,
  onPullRefresh: l,
  locationKey: n,
  pageContainer: u = z,
  onMenuReady: m
}) => {
  Q("Communication");
  const { IsImpersonating: d, User: g } = S(), { setScrollPosition: v, restoreScrollPosition: k } = H(), [t, i] = N("Messaging", {
    selectedFolderId: "1",
    selectedMessageIds: [],
    unreadOnly: !1,
    status: 1,
    staleDate: /* @__PURE__ */ new Date()
  }, "session"), {
    selectedFolderId: a,
    selectedMessageIds: p,
    unreadOnly: A,
    status: o,
    staleDate: F
  } = t;
  w(() => {
    n && k(n);
  }, []);
  const { isFetching: D, refetch: O } = new C.archive({ data: p }).ToQuery(), { isFetching: T, refetch: R } = new C.folders.markAllRead({ folderId: a }).ToQuery(), L = (r) => {
    switch (r.key) {
      case 1:
        R();
        break;
      case 2:
        i({
          ...t,
          status: 3
          /* ArchivingRead */
        });
        break;
      case 3:
        i({
          ...t,
          status: 4
          /* ArchivingAll */
        });
        break;
      case 4:
      // archive selected
      case 5:
        i({
          ...t,
          status: 2
          /* Archiving */
        });
        break;
    }
  };
  w(() => {
    if (m) {
      const r = d ? void 0 : x(a, o);
      m(r, L);
    }
  }, [a, o, d, m]);
  const P = (r) => {
    o === 1 ? (n && v(n), e(r)) : p.indexOf(r) > -1 ? i({ ...t, selectedMessageIds: p.filter((E) => E !== r) }) : i({ ...t, selectedMessageIds: [...p, r] });
  }, B = async () => {
    await O(), I();
  }, I = () => {
    i({ ...t, status: 1, selectedMessageIds: [], staleDate: /* @__PURE__ */ new Date() });
  }, j = () => {
    i({ ...t, staleDate: /* @__PURE__ */ new Date() }), l == null || l();
  }, M = a === "1" ? "Archive" : "Restore";
  return /* @__PURE__ */ h(y, { children: [
    /* @__PURE__ */ s(V, { onPullComplete: j }),
    /* @__PURE__ */ h(u, { sx: { display: "flex", flexFlow: "column", gap: 1 }, children: [
      /* @__PURE__ */ s(
        q,
        {
          open: D || T,
          text: "Updating messages"
        }
      ),
      /* @__PURE__ */ s(
        W,
        {
          open: o === 4 || o === 3,
          all: o === 4,
          folderId: a,
          onMessagesArchived: I,
          onClose: () => i({
            ...t,
            status: 1
            /* Reading */
          })
        }
      ),
      o === 2 && /* @__PURE__ */ s(y, { children: /* @__PURE__ */ h(G, { severity: "info", children: [
        /* @__PURE__ */ h("div", { children: [
          "Tap Messages to select them, then tap ",
          M
        ] }),
        /* @__PURE__ */ s(b, { sx: { mt: 1 }, onClick: () => i({
          ...t,
          selectedMessageIds: [],
          status: 1
          /* Reading */
        }), children: "Cancel" }),
        /* @__PURE__ */ s(b, { sx: { mt: 1 }, variant: "contained", onClick: B, children: M })
      ] }) }),
      o !== 2 && /* @__PURE__ */ s(
        X,
        {
          selectedFolderId: a,
          onFolderSelected: (r) => i({ ...t, selectedFolderId: r }),
          unreadOnly: A,
          onUnreadOnlyChanged: (r) => i({ ...t, unreadOnly: r }),
          newMessageButton: /* @__PURE__ */ s(Y, { onNewMessage: c, personType: (g == null ? void 0 : g.PersonType) ?? Z.PersonTypeEnum.Parent })
        }
      ),
      /* @__PURE__ */ s(
        U,
        {
          folderId: a,
          pageLength: 10,
          unreadOnly: A,
          onClick: P,
          selectedIds: p,
          staleDate: F,
          setReadOnClick: o === 1 && !d
        }
      )
    ] })
  ] });
}, Ve = (e, c, l, n, u, m, d) => ({ menuItems: l ? void 0 : x(e, c), handleMenuItemClick: (k) => {
  switch (k.key) {
    case 1:
      n();
      break;
    case 2:
      u();
      break;
    case 3:
      m();
      break;
    case 4:
    // archive selected
    case 5:
      d();
      break;
  }
} });
export {
  Ue as MessagingListView,
  _ as MessagingStatus,
  x as getMessageMenu,
  Ve as useMessagingMenu
};
//# sourceMappingURL=MessagingListView.js.map
